// src/api/axios.js
import axios from "axios";

// 创建 Axios 实例
const axiosInstance = axios.create({
  baseURL: "/", // 基础 URL
  timeout: 5000, // 超时时间
});

// 请求拦截器
axiosInstance.interceptors.request.use(
  (config) => {
    // 可以在这里添加 token 或其他请求头
    return config;
  },
  (error) => {
    return Promise.reject(error);
  }
);

// 响应拦截器
axiosInstance.interceptors.response.use(
  (response) => {
    return response.data; // 直接返回 data，简化调用
  },
  (error) => {
    return Promise.reject(error);
  }
);

export default axiosInstance;
